import React from 'react'
import { CiLocationOn } from "react-icons/ci";
import imageOne from '../../../assest/farmstay/108.jpeg'
import './housedetailsherosection.scss'

const HouseDetailsHeroSection = () =>
{
	const handleScrollToContact = () =>
	{
		const section = document.getElementById("contact-section");
		
		if (section)
		{
			section.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}
	};
	
	return (
		<section className="HouseDetailsHeroSection-hero-section">
			<div className="hero-wrapper">
				<img
					className="hero-img"
					src={imageOne}
					alt="Farm Stay"
				/>

				<div className="hero-overlay"></div>

				<div className="hero-card glass-panel">
					<span className="badge">Farm Stay</span>

					<h1>Hatur Farm Stay</h1>

					<p className="location">
						<CiLocationOn className="icon" />
						Hattur, Bijapur road, Solapur, Maharashtra, India
					</p>

					<div className="price">
						₹4,000*<span>/ night (Upto 8 people*)</span>
					</div>

					<p className="description">
						Enjoy a peaceful farm stay surrounded by nature. Perfect for relaxing weekends, family outings, and a refreshing escape from city life.
					</p>

					<button className="btn-full" onClick={handleScrollToContact}>Check Availability</button>
				</div>
			</div>
		</section>
	);
};

export default HouseDetailsHeroSection;